export const PORTAL_RADIO_OPTIONS = {
	AGENTS_AND_ADMINS: 'AGENTS_AND_ADMINS',
	ONLY_ADMINS: 'ONLY_ADMINS',
} as const;
